// src/context/ProductsContext.tsx
import { createContext, useContext, useEffect, useState } from "react";
import getProducts from "@/api/getProducts";
import type { Products } from "../types";

const ProductsContext = createContext<{ products: Products[] }>({
  products: [],
});

export const ProductsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [products, setProducts] = useState<Products[]>([]);

  useEffect(() => {
    getProducts().then(setProducts);
  }, []);

  return (
    <ProductsContext.Provider value={{ products }}>
      {children}
    </ProductsContext.Provider>
  );
};

export const useProducts = () => useContext(ProductsContext);
